import React from 'react'
import { Spin } from 'antd'
import PropTypes from 'prop-types'

import { StyledEditableRowLoaderContainer } from '../styled'

const EditableTableRowLoader = ({ height, isLoading }) => {
  if (!isLoading) {
    return null
  }

  return (
    <StyledEditableRowLoaderContainer height={height}>
      <Spin />
    </StyledEditableRowLoaderContainer>
  )
}

EditableTableRowLoader.propTypes = {
  isLoading: PropTypes.bool,
  height: PropTypes.number,
}
EditableTableRowLoader.defaultProps = {
  isLoading: false,
  height: 0,
}

export default EditableTableRowLoader
